export const spacing = [0, 4, 8, 12, 16, 24, 32, 48, 64];

export const layout = {
  padding: {
    normal: "140px",
    tablet: "30px",
  },
};
